import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVolvoComponent } from './simple-icons-volvo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVolvoComponent ],
    exports:      [ SimpleIconsVolvoComponent ],
    bootstrap:    []
})
export class SimpleIconsVolvoModule {}
